import './styles.scss';
import { app, firmadosConfig } from './credenciales';
import { getAuth, getIdToken, signInWithEmailAndPassword, createUserWithEmailAndPassword, User  } from "firebase/auth";
import { solicitarArchivo, callTwilio, getPdfFromFirebase, mfaEmail, obtenerDocumentosUsuario, orchestrateAutofirmaBatch } from './solicitudes';
import { firmarArchivo, registrarUsuarioEnDb } from './actualizaciones';
import SignaturePad from './signatureAPI/signature_pad'; // Import the SignaturePad class
import { crearHash } from './hash';

interface UserData {
    ip?: string,
    correo?: string,
    fecha?: Date,
    doc?: string,
    empresa?: string,
    token?: string,
    encriptado?: string,
    fechaPoliticasPrivacidad?: Date,
    fechaPoliticasEncriptado?: Date,
    navegador?: string,
    navegadorPoliticaPrivacidad?: string,
    ipPoliticaPrivacidad?: string,
    ip_mfa?: string,
    fecha_mfa?: Date,
    navegador_mfa?: string
}
interface DocumentoData {
    fecha?: Date,
    ip?: string,
    data?: any,
    firmaData?: any,
    firmaPNGBase64?: string,
    documento?: string,
    fechaFirmaDocumento?: Date,
    navegadorFirmaDocumento?: string,
    numDoc?: string
}

const fecha: Date = new Date();
const auth = getAuth(app);

let wrapper = document.getElementById("documentoIframe") as HTMLDivElement;
let canvas = wrapper.querySelector("canvas") as HTMLCanvasElement;
let signaturePad = new SignaturePad(canvas, {
    // It's Necessary to use an opaque color when saving image as JPEG;
    // this option can be omitted if only saving as PNG or SVG
    backgroundColor: 'rgba(255, 255, 255, 0)'
});
let userData: UserData = {};
let documentoData: DocumentoData = {};
let iniformularioAutenticacionIniciado:number = 0;
let iniCanvasIniciado:number = 0;
let idToken:string = "";
let metodoFirmaActual: 'biometrica' | 'autofirma' = 'biometrica';

/**
 * Funcion que se dispara al cargar la pagina por primera vez
 * @return void
 */
const inic = async () => {
    // Esperar a que Firebase Auth determine el estado del usuario
    await new Promise(resolve => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            unsubscribe();
            resolve(user);
        });
    });

    let user = auth.currentUser;
    const docId = getDocumentIdFromUrl(); 

    // CASO A: ALGUIEN QUIERE FIRMAR UN DOCUMENTO (Hay ID en URL)
    if (docId) {
        if (!user) {
            try { await signInWithEmailAndPassword(auth, firmadosConfig.user, firmadosConfig.pass); user = auth.currentUser; } catch (e) {} 
        }
        if (user) idToken = await getIdToken(user);
        
        // Cargar documento...
        const bodyRequest = { docId: docId };
        try {
             const res: any = await solicitarArchivo(bodyRequest, idToken);
             if(!res.error) {
                 const data = { docId: docId, doc: res.data };
                 cargarPdf(idToken, data);
             }
        } catch (e) { console.error(e); }

    // CASO B: PANEL DE ADMINISTRACIÓN (NO hay ID en URL)
    } else {
        const body = document.getElementById("body") as HTMLElement;
        body.style.visibility = "visible";

        // VERIFICACIÓN ESTRICTA: Solo entramos si tiene email, no es anónimo Y NO ES LA CUENTA DEL SISTEMA
        if (user && user.email && !user.isAnonymous && user.email !== firmadosConfig.user) {
            idToken = await getIdToken(user);
            renderDashboard(); 
        } else {
            // Si hay un usuario anónimo o es la cuenta genérica del sistema, cerramos su sesión y pedimos login real
            if (user) await auth.signOut();
            renderLogin();
        }
    }
}


const renderSeleccionFirma = (idToken: string, data: any) => {
    const body = document.getElementById("body") as HTMLElement;
    body.style.visibility = "visible";

    let container = document.getElementById("seleccion-firma-app") as HTMLDivElement;
    if (!container) {
        container = document.createElement("div");
        container.id = "seleccion-firma-app";
        container.style.width = "100%";
        container.style.minHeight = "100vh";
        container.style.backgroundColor = "#f4f6f9"; 
        container.style.position = "absolute"; 
        container.style.top = "0";
        container.style.left = "0";
        container.style.zIndex = "1000";
        container.style.display = "flex";
        container.style.justifyContent = "center";
        container.style.alignItems = "center";
        document.body.appendChild(container);
    }
    
    ocultarTodo();
    container.style.display = "flex"; 

    const docName = data.doc.nombre_documento || "Documento sin título";

    const urlLimpia = window.location.origin + window.location.pathname;
    container.innerHTML = `
        <div style="max-width:500px; padding:40px; border:1px solid #ccc; border-radius:10px; text-align:center; background:white; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
            
            <p style="margin-bottom:10px; color:#888; font-size:14px; text-transform:uppercase; letter-spacing:1px;">
                Va a firmar el documento
            </p>
            
            <h2 style="margin-bottom:35px; color:#222; font-size:28px; line-height:1.3; word-break:break-word;">
                ${docName}
            </h2>
            
            <p style="margin-bottom:20px; color:#555; font-size:16px; font-weight:600;">
                Seleccione un método de firma:
            </p>
            
            <div style="display:flex; flex-direction:column; gap:15px;">
                <button id="btnSelAutofirma" style="padding:15px; background:#4dd702; color:white; border:none; border-radius:5px; cursor:pointer; font-weight:bold; font-size:16px;">Firmar con AutoFirma</button>
                <button id="btnSelBiometrica" style="padding:15px; background:#007bff; color:white; border:none; border-radius:5px; cursor:pointer; font-weight:bold; font-size:16px;">Firma Biométrica</button>
            </div>
            
            <div style="margin-top: 30px; border-top: 1px solid #eee; padding-top: 20px;">
                <a href="${urlLimpia}" style="color: #888; text-decoration: underline; font-size: 14px; cursor: pointer;">
                    Ver todos mis documentos pendientes
                </a>
            </div>
        </div>
    `;

    /*// Acción: FIRMAR CON AUTOFIRMA
    document.getElementById("btnSelAutofirma")?.addEventListener("click", async () => {
        container.style.display = "none";
        try {
            const response = await orchestrateAutofirmaBatch(
                [data.docId], 
                idToken,
                true,
                mostrarLoader,
                ocultarLoader,
                (msg) => { alert(msg); }
            );

            if (response.error) {
                alert(`Error en el proceso de firma: ${response.msg || 'Error desconocido.'}`);
                container.style.display = "flex"; 
            } else {
                const res: any = await solicitarArchivo({ docId: data.docId }, idToken);
                if(!res.error) {
                    cargarPdf(idToken, { docId: data.docId, doc: res.data });
                }
            }
        } catch (error: any) {
            ocultarLoader();
            console.error(error);
            alert(`No se pudo firmar el documento.\n\nDetalle: ${error.message || "Error desconocido"}\n\n⚠️ Si el PDF está protegido con contraseña, por favor, elimínela antes de intentar firmarlo.`);
            container.style.display = "flex"; // Volvemos a mostrar el menú
        }
    });

    // Acción: FIRMA BIOMÉTRICA (MFA Clásico)
    document.getElementById("btnSelBiometrica")?.addEventListener("click", () => {
        container.style.display = "none";
        iniciarFlujoMFA(idToken, data);
    });*/

    // Acción: FIRMAR CON AUTOFIRMA
    document.getElementById("btnSelAutofirma")?.addEventListener("click", () => {
        container.style.display = "none";
        metodoFirmaActual = 'autofirma'; // Guardamos la elección
        // Saltamos el MFA y mostramos el documento directamente
        cargarDocumento(idToken, data); 
    });

    // Acción: FIRMA BIOMÉTRICA (MFA Clásico)
    document.getElementById("btnSelBiometrica")?.addEventListener("click", () => {
        container.style.display = "none";
        metodoFirmaActual = 'biometrica'; // Guardamos la elección
        iniciarFlujoMFA(idToken, data); // Este ya cargará el documento tras el SMS/Email
    });
};

const iniciarFlujoMFA = (idToken: string, data: any) => {
    const mfa_email = true;
    
    if (data.doc.telefono && data.doc.telefono.length >= 9) {
        mostrar("autenticacion");
        const validar = document.getElementById("validar") as HTMLButtonElement;
        const mfa = document.getElementById("mfa") as HTMLInputElement;

        crearVerificacionMFA(idToken, data.docId, data.doc.telefono);

        const btnReenviar = document.getElementById("reenviarMFA") as HTMLButtonElement;
        if (btnReenviar) {
            btnReenviar.onclick = async function (event) {
                event.preventDefault();
                mostrarLoader("Reenviando código...");
                try {
                    await crearVerificacionMFA(idToken, data.docId, data.doc.telefono, true);
                    ocultarLoader();
                    alert("Código MFA reenviado por SMS.");
                } catch (error) {
                    ocultarLoader();
                    alert("Hubo un error al reenviar el código. Revisa la consola.");
                }
            };
        }

        validar.onclick = function (event) {
            const mfaCode = mfa.value;
            event.preventDefault();
            
            if (mfaCode === "") {
                mostrarError("Por favor, introduce el código MFA."); return false;
            } else if (mfaCode.length != 6) {
                mostrarError("El código MFA debe tener 6 caracteres."); return false;
            }
            
            validarCodigoMFA(idToken, data.docId, data.doc.telefono, mfaCode)
            .then(isValid => {
                if (isValid) {
                    auditoriaMFA(true);
                    cargarDocumento(idToken, data);
                } else {
                    mostrarError("Código MFA incorrecto. Inténtelo de nuevo.");
                }
            })
            .catch(error => {
                mostrarError("Error en la validación MFA.");
            });
        };
    } else if (mfa_email) {
        mostrar("autenticacion");
        const validar = document.getElementById("validar") as HTMLButtonElement;
        const mfa = document.getElementById("mfa") as HTMLInputElement;

        crearVerificacionMFAemail(idToken, data.docId, data.email);

        const btnReenviar = document.getElementById("reenviarMFA") as HTMLButtonElement;
        if (btnReenviar) {
            btnReenviar.onclick = async function (event) {
                event.preventDefault();
                mostrarLoader("Reenviando código...");
                try {
                    await crearVerificacionMFAemail(idToken, data.docId, data.email, true);
                    ocultarLoader();
                    alert("Código MFA reenviado al email.");
                } catch (error) {
                    ocultarLoader();
                    alert("Hubo un error al reenviar el código.");
                }
            };
        }

        validar.onclick = function (event) {
            const mfaCode = mfa.value;
            event.preventDefault();
            
            if (mfaCode === "") {
                mostrarError("Por favor, introduce el código MFA."); return false;
            } else if (mfaCode.length != 6) {
                mostrarError("El código MFA debe tener 6 caracteres."); return false;
            }
            
            validarCodigoMFAemail(idToken, data.docId, data.email, mfaCode)
            .then(isValid => {
                if (isValid) {
                    auditoriaMFA(true);
                    cargarDocumento(idToken, data);
                } else {
                    mostrarError("Código MFA incorrecto. Inténtelo de nuevo.");
                }
            })
            .catch(error => {
                mostrarError("Error en la validación MFA.");
            });
        };
    } else {
        mostrar("autenticacion");
        auditoriaMFA(false);
        cargarDocumento(idToken, data);
    }
};


const cargarPdf = async (idToken:string, data:any, modoLecturaAdmin: boolean = false)=>{
    console.log("EnviarMail:"+JSON.stringify(data.doc));
    const body = document.getElementById("body") as HTMLElement;
    body.style.visibility = "visible"; 
    
    // Ocultar dashboard si estaba abierto
    const adminApp = document.getElementById("admin-app") as HTMLDivElement;
    if(adminApp) adminApp.style.display = "none";
    
    mostrarLoader("Cargando");
    const esLectura = modoLecturaAdmin;

    const estado = data.doc.estado;

    if (estado == "Firmado") {
        console.log("Firmado");
        ocultarLoader();
        const msg = `
            <span class="titulo">Documento Firmado</span>
            <span class="mensaje">El documento ya ha sido firmado.</span>
            <a class="descargar" target="_blank" href="${data.doc.url_firmado}">Descargar documento firmado</a>
        `;
        mostrarMensajeDocumentoFirmado(msg);
    } else if ((estado == "Pendiente") || (estado == "Esperando firma")) {
        console.log("Pendiente de firmar");

        // --- SI ES LECTURA (ADMIN) SALTAMOS TODO ---
        if (esLectura) {
            console.log("Modo Lectura Admin: Saltando MFA y Controles");
            auditoriaMFA(false); 

            mostrar("documentoIframe");
            insertarDocDOMEnIframe(data, true);

            const barraPoliticas = document.getElementById("barraPoliticas") as HTMLDivElement;
            if(barraPoliticas) barraPoliticas.style.display = "none";
            const iframe = document.getElementById("iframe") as HTMLIFrameElement;
            if(iframe) iframe.style.height = "100vh";

            agregarBotonVolver();
            ocultarLoader();
            return; 
        }

        // --- SI ES USUARIO NORMAL, LE MOSTRAMOS EL MENÚ DE SELECCIÓN ---
        ocultarLoader();
        renderSeleccionFirma(idToken, data);

    } else {
        mostrarError("Error al cargar el documento.");
        return false;
    }
}

async function crearVerificacionMFA(idToken:string, docId:string, phoneNumber:string, forzarReenvio: boolean = false): Promise<boolean> {
    if (!phoneNumber.startsWith("+"))
        phoneNumber="+34"+phoneNumber;

    console.log("Crear verificación MFA: "+phoneNumber);
    const bodyRequest = {
        ope: "alta",
        docId: docId,
        telefono: phoneNumber,
        forzarReenvio: forzarReenvio
    };
    try {
        const res: any = callTwilio(bodyRequest, idToken);

        return Promise.resolve(true);
    } catch (e) {
        return Promise.reject(false);
    }   
}

async function validarCodigoMFA(idToken:string, docId:string, phoneNumber:string, codigo: string): Promise<boolean> {
    if (!phoneNumber.startsWith("+"))
        phoneNumber="+34"+phoneNumber;

    console.log("Validar código MFA '" + codigo + "' para nº: "+phoneNumber);
    const bodyRequest = {
        ope: "verificacion",
        docId: docId,
        telefono: phoneNumber,
        mfa: codigo
    };

    try {
        const res: any = await callTwilio(bodyRequest, idToken);

        //console.log("Resultado de Twilio:", res);
        const esValido = res?.error === false;
        return Promise.resolve(esValido);
    } catch (e) {
        //console.error("Error al validar el código:", e);
        console.error("Error al validar el código");
        return Promise.reject(false);
    }
}

async function crearVerificacionMFAemail(idToken:string, docId:string, email:string, forzarReenvio: boolean = false): Promise<boolean> {
    console.log("Crear verificación MFA email: "+email);
    const bodyRequest = {
        ope: "alta",
        docId: docId,
        email: email,
        forzarReenvio: forzarReenvio
    };
    try {
        const res: any = await mfaEmail(bodyRequest, idToken);

        return Promise.resolve(true);
    } catch (e) {
        return Promise.reject(false);
    }   
}

async function validarCodigoMFAemail(idToken:string, docId:string, email:string, codigo: string): Promise<boolean> {
    console.log("Validar código MFA '" + codigo + "' para email: "+email);
    const bodyRequest = {
        ope: "verificacion",
        docId: docId,
        email: email,
        mfa: codigo
    };

    try {
        const res: any = await mfaEmail(bodyRequest, idToken);

        //console.log("Resultado de Firebase:", res);
        const esValido = res?.error === false;
        return Promise.resolve(esValido);
    } catch (e) {
        //console.error("Error al validar el código:", e);
        console.error("Error al validar el código");
        return Promise.reject(false);
    }
}

/**
 * Funcion que se obtiene el id del documento desde el request de la URL
 * @return {String} - El id del documento
 */
function getDocumentIdFromUrl(): string | null {
    const params = new URLSearchParams(window.location.search);
    return params.get('docId');
}

/**
 * Guarda la auditoria para la validación del MFA
 * @return void
 */
const auditoriaMFA = async (mfa:boolean) => {
    if (mfa) {
        const ip: any = await optenerIp();
        if (ip != undefined && ip.length > 0) {
            asignarValorAVariable("userData", "ip_mfa", ip);
        } else {
            asignarValorAVariable("userData", "ip_mfa", "-");
        }

        const navegadorInfo = navigator.userAgent;
        if(navegadorInfo != undefined){
            asignarValorAVariable("userData", "navegador_mfa", navegadorInfo);
        } else {
            asignarValorAVariable("userData", "navegador_mfa", "-");
        }

        asignarValorAVariable("userData", "fecha_mfa", new Date());
    } else {
        asignarValorAVariable("userData", "ip_mfa", "-");
        asignarValorAVariable("userData", "navegador_mfa", "-");
    }
}


/**
 * Carga el documento solicitado en la URL al cargar la pagina por primera vez
 * @return void
 */
const cargarDocumento = async (idToken:String, data:any) => {     
    console.log("Cargar documento");
    const encriptado: string = getParameterByName("?");
    //const ip: any = await optenerIp();

    /*if (encriptado == undefined || encriptado.length == 0) {
        mostrarError("Error en encriptado", true);
        return false;
    }*/

    /*if (ip == undefined || ip.length == 0) {
        mostrarError("Hemos encontrado un error en el campo ip", true);
        return false;
    }

    const navegadorInfo = navigator.userAgent;
    if(navegadorInfo != undefined){
        asignarValorAVariable("userData", "navegador", navegadorInfo);
    }else{
        mostrarError("Hemos encontrado un error en los datos del navegador", true);
        return false;
    }

    asignarValorAVariable("userData", "ip", ip);
    asignarValorAVariable("userData", "fecha", new Date());*/
    asignarValorAVariable("userData", "encriptado", encriptado);
    const numDoc = data.doc.nombre_documento;
    asignarValorAVariable("documentoData", "numDoc", numDoc);    

    try {
        const estado = data.doc.estado;
        if ((estado == "Pendiente") || (estado == "Esperando firma")) {
            insertarDocDOMEnIframe(data, false);
            //const pdfUrl = data.doc.url ? data.doc.url : data.doc;
            //loadPDF(pdfUrl);
            ocultarLoader();
            mostrar("documentoIframe");
        } else {
            throw("Documento no encontrado");
        }
    } catch (e) {
        ocultarLoader();
        const msg = `
            <span class="titulo">Enlace no válido</span>
            <span class="mensaje">No se ha encontrado el documento o se ha cancelado la solicitud de firma.</span>
        `;
        mostrarMensajeDocumentoFirmado(msg);
    }    
}

/**
 * Inicializa las funciones del canvas 
 * @return void
 */
const iniCanvas = () => {
    let clearButton = wrapper.querySelector("[data-action=clear]") as HTMLButtonElement;
    let aceptarButton = wrapper.querySelector("[data-action=aceptar]") as HTMLButtonElement;
    let img_firmaPNGBase64 = wrapper.querySelector("#img_firmaPNGBase64") as HTMLImageElement;

    clearButton.addEventListener("click", function (event) {
        canvas.style.display = "block";
        img_firmaPNGBase64.style.display = "none";
        console.log("canvas limpiado")
        signaturePad.clear();
    });

    aceptarButton.addEventListener("click", async function (event) {
        if (signaturePad.isEmpty()) {
            mostrarError("No podemos aceptar el documento sin que este firmado antes", false);
            return false;
        }

        let menuDocumento = wrapper.querySelector("#menuDocumento") as HTMLDivElement;
        let codigoVerificacionFirma = document.getElementById("codigoVerificacionFirma") as HTMLDivElement;
        let signaturePadDiv = document.getElementById("signature-pad") as HTMLDivElement;

        const firmaData = {
            xml: signaturePad.toISOData(),
            hashFirma: crearHash(JSON.stringify(signaturePad.toISOData())),
        };
        asignarValorAVariable("documentoData", "firmaData", firmaData);

        if(documentoData.firmaData == undefined || documentoData.firmaData.xml == undefined || documentoData.firmaData.hashFirma == undefined){
            mostrarError("No existen datos en la firma.", false);
            return false;
        }

        if (firmaData == undefined || firmaData.xml == undefined || firmaData.hashFirma == undefined) {
            mostrarError("Hemos tenido un problema al generar el hash de la firma.", false);
            return false;
        }  
        
        // Generamos un PNG base64 a partir de la firma
        const firmaPNGBase64 = signaturePad.toDataURL();  
        if (!firmaPNGBase64) {
            mostrarError("Hemos tenido un problema al generar el PNG.", false);
            return false;
        }

        asignarValorAVariable("documentoData", "firmaPNGBase64", firmaPNGBase64);
        if(documentoData.firmaPNGBase64 == undefined || documentoData.firmaPNGBase64.length == 0){
            mostrarError("No existe documento.", false);
            return false;
        }

        asignarValorAVariable("documentoData", "fechaFirmaDocumento", new Date());
        const navegadorInfo = navigator.userAgent;
        if(navegadorInfo != undefined){
            asignarValorAVariable("documentoData", "navegadorFirmaDocumento", navegadorInfo);
        }else{
            mostrarError("Hemos encontrado un error en los datos del navegador", true);
            return false;
        }

        asignarValorAVariable("documentoData", "fecha", new Date());
        asignarValorAVariable("documentoData", "ip", await optenerIp());
        asignarValorAVariable("documentoData", "numDoc", await optenerIp());
        
        // --- INICIO DE COMUNICACIÓN CON EL BACKEND ---
        mostrarLoader("Firmando documento de forma segura. Por favor, espere...");
        const body_request2: any = {
            id_documento: getDocumentIdFromUrl(),
            documentoData: documentoData,
            userData: userData,
        };
        
        console.log("Enviando orden de firma...");

        // Llamamos a tu función externa (la cual ya hace las 100 comprobaciones de espera)
        const archivoCertificado: any = await firmarArchivo(body_request2);
        
        // Si el backend falla (ej. PDF protegido), tu función lo lee, devuelve false y lo atrapamos aquí
        if(archivoCertificado.exitoso === false){
            mostrarError(archivoCertificado.msg, false);
            return false;
        }

        // Si todo va bien, el bucle terminó, tenemos las URL y mostramos la pantalla final
        console.log("Firmado exitosamente: " + JSON.stringify(archivoCertificado));
        ocultarLoader();
        
        const msg = `
            <span class="titulo">Documento Firmado</span>
            <span class="mensaje">Proceso finalizado correctamente</span>
            <a class="descargar" target="_blank" href="${archivoCertificado.url}">Descargar documento firmado</a>
            <a class="descargar" target="_blank" href="${archivoCertificado.url_registro_auditoria}">Descargar registro auditoria</a>
        `;
        mostrarMensajeDocumentoFirmado(msg); 
    });

    // On mobile devices it might make more sense to listen to orientation change,
    // rather than window resize events.
    window.onresize = resizeCanvas;
    resizeCanvas();
}

/**
 * Asigna valor a la variable documentoData o userData dependiendo de lo indicado
 * @param String variable = nombre de la variable que se desea modificar
 * @param String key = propiedad de la variable que se desea modificar
 * @param String valor = valor de la propieda de la variable que se desea modificar
 * @return documentoData<any> |  userData<any>
 */
const asignarValorAVariable = (variable:string, key:string, valor:any) => {
    if (variable == "documentoData") {
        switch (key) {
            case "fecha":
            case "ip":
            case "data":
            case "firmaData":
            case "documento":
            case "fechaFirmaDocumento":
            case "firmaPNGBase64":
            case "navegadorFirmaDocumento":
            case "numDoc":
                documentoData[key] = valor;
                break;
        }
        return documentoData;
    }else if (variable == "userData") {
        switch (key) {
            case "fecha":
            case "ip":
            case "correo":
            case "doc":
            case "empresa":
            case "token":
            case "encriptado":
            case "fechaPoliticasPrivacidad":
            case "fechaPoliticasEncriptado":         
            case "navegador":
            case "navegadorPoliticaPrivacidad":  
            case "ipPoliticaPrivacidad":
            case "ip_mfa":
            case "navegador_mfa":
            case "fecha_mfa":
                userData[key] = valor;
                break
        }
        return userData;
    }
}

/**
 * Restura el DOM del documento 
 * @return void
 */
const restaurarDOMDocument = () => {
    let menuDocumento = wrapper.querySelector("#menuDocumento") as HTMLDivElement;
    let img_firmaPNGBase64 = wrapper.querySelector("#img_firmaPNGBase64") as HTMLImageElement;
    let signaturePadDiv = wrapper.querySelector("#signature-pad") as HTMLDivElement;

    canvas.style.display = "block";
    img_firmaPNGBase64.style.display = "none";
    menuDocumento.style.display = "flex";
    signaturePadDiv.classList.remove("ocultar-signature-pad--footer");
}

/**
 * Decontruye la url y optiene el valor del parametro que se le indique
 * @param String parametro del que se desea optener el valor
 * @return String valor del parametro | vacio
 */
const getParameterByName = (parametro: string) => {
    try{
        if (parametro != "?") {
            parametro = parametro.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            const regex = new RegExp("[\\?&]" + parametro + "=([^&#]*)"),
            results = regex.exec(location.search);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        }else {
            const url:string = location.search || "";
            return url.substring(1, url.length);
        }   
    }catch(error){
        console.error(error);
        return "";
    } 
}

/**
 * Optiene la ip del usuario, por medio de la solicitud de un servicio online
 * @return Promise<string>
 */
const optenerIp = async (): Promise<string> => {
    return new Promise((resolve) => {
        fetch('https://api.ipify.org?format=json')
            .then(response => response.json())
            .then((data: any) => {
                const ipAddress: string = data.ip || "";
                return resolve(ipAddress);
            })
            .catch((error: any) => {
                console.error('Error al obtener la dirección IP:', error);
                return resolve("");
            });
    })
}

/**
 * Muestra un elemeto del DOM segun se le indique
 * @param String elemento del DOM
 * @return void
 */
const mostrar = (ele: string) => {
    const autenticacionForm = document.getElementById("autenticacion") as HTMLDivElement;
    const documentoIframe = document.getElementById("documentoIframe") as HTMLDivElement;
    const pdfViewer: HTMLCanvasElement | null = document.getElementById('pdfViewer') as HTMLCanvasElement;
    const context: CanvasRenderingContext2D | null = canvas.getContext('2d');
    const popUpFirma = document.getElementById("popUpFirma") as HTMLDivElement;

    if (ele == "autenticacion") {
        console.log("Mostrando autenticacion");
        autenticacionForm.style.display = "flex";
        documentoIframe.style.display = "none";
        popUpFirma.style.display = "none";
        popUpFirma.className = "";
    } else if (ele == "documentoIframe") {
        console.log("Mostrando documentoIframe");
        autenticacionForm.style.display = "none";
        documentoIframe.style.display = "block";
        popUpFirma.style.display = "none";
        popUpFirma.className = "";
        // El modulo SignaturePad se debe de ejecute primero que iniCanvas
        if(!iniCanvasIniciado){ iniCanvas(); }
        iniCanvasIniciado++;
    } else if(ele == "popUpFirma") {
        console.log("Mostrando popUp");
        autenticacionForm.style.display = "none";
        popUpFirma.style.display = "block";
        popUpFirma.className = "mostrar";
        documentoIframe.style.display = "block";
        resizeCanvas();
    } 
    ocultarLoader();
}

/**
 * Oculta todos los elementos del DOM
 * @return void
 */
const ocultarTodo = () => {
    const autenticacionForm = document.getElementById("autenticacion") as HTMLDivElement;
    const documentoIframe = document.getElementById("documentoIframe") as HTMLDivElement;
    const popUpFirma = document.getElementById("popUpFirma") as HTMLDivElement;
    const adminApp = document.getElementById("admin-app") as HTMLDivElement; 
    const seleccionApp = document.getElementById("seleccion-firma-app") as HTMLDivElement;

    if(autenticacionForm) autenticacionForm.style.display = "none";
    if(documentoIframe) documentoIframe.style.display = "none";
    if(popUpFirma) popUpFirma.style.display = "none";
    if(adminApp) adminApp.style.display = "none";
    if(seleccionApp) seleccionApp.style.display = "none";
}

/**
 * Adjust canvas coordinate space taking into account pixel ratio,
 * to make it look crisp on mobile devices.
 * This also causes canvas to be cleared.
 */
const resizeCanvas = () => {
    // When zoomed out to less than 100%, for some very strange reason,
    // some browsers report devicePixelRatio as less than 1
    // and only part of the canvas is cleared then.
    let ratio = Math.max(window.devicePixelRatio || 1, 1);

    // This part causes the canvas to be cleared
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    if (canvas != null) {
        canvas.getContext("2d")!.scale(ratio, ratio);
    }

    // This library does not listen for canvas changes, so after the canvas is automatically
    // cleared by the browser, SignaturePad#isEmpty might still return false, even though the
    // canvas looks empty, because the internal data of this library wasn't cleared. To make sure
    // that the state of this library is consistent with visual state of the canvas, you
    // have to clear it manually.
    signaturePad.clear();
}

/**
 * Descargar la firma
 * @param any dataURL
 * @param any filename
 * @return Promise
 */
const download = async (dataURL: any, filename: any): Promise<any> => {
    return new Promise((resolve) => {
        if (navigator.userAgent.indexOf("Safari") > -1 && navigator.userAgent.indexOf("Chrome") === -1) {
            window.open(dataURL);
        } else {
            var blob = dataURLToBlob(dataURL);
            var url = window.URL.createObjectURL(blob);

            var a = document.createElement("a");
            a.setAttribute("style", "display: none");
            a.href = url;
            a.download = filename;

            document.body.appendChild(a);
            a.click();

            window.URL.revokeObjectURL(url);
        }
        resolve(true);
    }).catch((err) => {
        console.error(err);
        return false;
    });
}

/**
 * One could simply use Canvas#toBlob method instead, but it's just to show
 * that it can be done using result of SignaturePad#toDataURL.
 * @param any dataURL
 */
const dataURLToBlob = (dataURL: any) => {
    // Code taken from https://github.com/ebidel/filer.js
    var parts = dataURL.split(';base64,');
    var contentType = parts[0].split(":")[1];
    var raw = window.atob(parts[1]);
    var rawLength = raw.length;
    var uInt8Array = new Uint8Array(rawLength);

    for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
}

/**
 * Inserta el documento en el DOM
 * @param data any documento a insertar
 * @return boolean true si ha logrado insartar el documento completo | false
 */
const insertarDocDOMEnIframe = (data: any, modoLectura: boolean = false) => {
    mostrarLoader("Estamos cargando el documento");
    
    const barraPoliticas = document.getElementById("barraPoliticas") as HTMLDivElement;
    const textosPoliticas = document.getElementById("textosPoliticas") as HTMLDivElement;
    if (barraPoliticas) {
        if (modoLectura) {
            barraPoliticas.style.display = "none";
        } else {
            barraPoliticas.style.display = "block"; // O "flex"
        }
    }

    if (textosPoliticas) {
        if (metodoFirmaActual === 'autofirma') {
            textosPoliticas.style.display = "none";
        } else {
            textosPoliticas.style.display = "block"; // O "flex"
        }
    }

    const iframe = wrapper.querySelector("#iframe") as HTMLIFrameElement;
    // const pdfViewer: HTMLElement | null = document.getElementById('pdfViewer') as HTMLElement;
    
    //const canvasPDF = wrapper.querySelector("#canvasPDF") as HTMLCanvasElement;
    //const context: CanvasRenderingContext2D = canvasPDF.getContext('2d') as CanvasRenderingContext2D;
    const firmar = wrapper.querySelector("#firmar") as HTMLButtonElement;
    const aceptarPoliticasDePrivacidadButton = wrapper.querySelector("[data-action=aceptarPoliticasPrivacidad]") as HTMLInputElement;
    const aceptarPoliticasEncriptadoButton = wrapper.querySelector("[data-action=aceptarPoliticasEncriptado]") as HTMLInputElement;
    const cerrarPopUp = wrapper.querySelector("#cerrarPopUp") as HTMLButtonElement;

    aceptarPoliticasDePrivacidadButton.addEventListener("click", async function (event) {
        if(aceptarPoliticasDePrivacidadButton.checked == true){
            asignarValorAVariable("userData", "fechaPoliticasPrivacidad", new Date());
            const navegadorInfo = navigator.userAgent;
            asignarValorAVariable("userData", "navegadorPoliticaPrivacidad", navegadorInfo);
            const ip: any = await optenerIp();
            asignarValorAVariable("userData", "ipPoliticaPrivacidad", ip);
        }else{
            delete userData.fechaPoliticasPrivacidad;
            delete userData.navegadorPoliticaPrivacidad;
            delete userData.ipPoliticaPrivacidad;
        }
        
    });

    aceptarPoliticasEncriptadoButton.addEventListener("click", function (event) {
        if(aceptarPoliticasEncriptadoButton.checked == true){
            asignarValorAVariable("userData", "fechaPoliticasEncriptado", new Date());
        }else{
            delete userData.fechaPoliticasEncriptado;
        }        
    }); 

    cerrarPopUp.addEventListener("click", function (event) {
        mostrar("documentoIframe");
    });
    
    const url = data.doc.url ? data.doc.url : data.doc;
    
    const bodyRequest = { url: url };  // El objeto que contiene la URL del PDF
    getPdfFromFirebase(bodyRequest, idToken)
        .then(result => {
            if (!result.error) {
                // Si no hay error, el PDF está listo para mostrarse
                const pdfUrl = result.data.pdfUrl;
                // Ahora puedes usar pdfUrl en un visor o iframe
                //iframe.src = pdfUrl;
                iframe.src = "/web/viewer.html?file="+encodeURIComponent(pdfUrl);
            } else {
                console.error(result.msg);  // Si ocurre un error, mostrar el mensaje
            }
        })
        .catch(error => {
            // Manejar el error si la promesa es rechazada
            console.error("Error al obtener el PDF:", error);
        });

    /*firmar.addEventListener("click", function (event) {
        if(aceptarPoliticasDePrivacidadButton.checked == false){
            alert("Debes aceptar la Politica de Privacidad antes de firmar el documento");
            return;
        }
        if(aceptarPoliticasEncriptadoButton.checked == false){
            alert("Debes aceptar la Politica de Encriptado antes de firmar el documento");
            return;
        }
        if(userData.fechaPoliticasPrivacidad == undefined || userData.fechaPoliticasEncriptado == undefined){
            alert("Al parecer aún no has aceptado la Politica de Privacidad y/o la Politica de Encriptado");
            return;
        }
        if(userData.navegadorPoliticaPrivacidad == undefined){
            mostrarError("Hemos encontrado un error en los datos del navegador", true);
            return false;
        }
        if (userData.ipPoliticaPrivacidad == undefined || userData.ipPoliticaPrivacidad.length == 0) {
            mostrarError("Hemos encontrado un error en el campo ipPoliticaPrivacidad", true);
            return false;
        }
        //console.log(userData)
        console.log("Mostramos caja de firma")
        mostrar("popUpFirma");
    });*/

    if (metodoFirmaActual === 'autofirma') {
        firmar.innerText = "Proceder a AutoFirma";
    } else {
        firmar.innerText = "Firmar Documento";
    }

    firmar.onclick = async function (event) {
        // SOLO exigimos políticas si es firma biométrica
        if (metodoFirmaActual === 'biometrica') {
            if(aceptarPoliticasDePrivacidadButton.checked == false){
                alert("Debes aceptar la Politica de Privacidad antes de firmar el documento");
                return;
            }
            if(aceptarPoliticasEncriptadoButton.checked == false){
                alert("Debes aceptar la Politica de Encriptado antes de firmar el documento");
                return;
            }
            if(userData.fechaPoliticasPrivacidad == undefined || userData.fechaPoliticasEncriptado == undefined){
                alert("Al parecer aún no has aceptado la Politica de Privacidad y/o la Politica de Encriptado");
                return;
            }
            if(userData.navegadorPoliticaPrivacidad == undefined){
                mostrarError("Hemos encontrado un error en los datos del navegador", true);
                return false;
            }
            if (userData.ipPoliticaPrivacidad == undefined || userData.ipPoliticaPrivacidad.length == 0) {
                mostrarError("Hemos encontrado un error en el campo ipPoliticaPrivacidad", true);
                return false;
            }
        }
        
        // --- FLUJO FINAL ---
        if (metodoFirmaActual === 'autofirma') {
            mostrarLoader("Iniciando AutoFirma...");
            try {
                const response = await orchestrateAutofirmaBatch(
                    [data.docId], 
                    idToken,
                    true, // es_enlace = true
                    mostrarLoader,
                    ocultarLoader,
                    (msg) => { alert(msg); }
                );

                if (response.error) {
                    alert(`Error en el proceso de firma: ${response.msg || 'Error desconocido.'}`);
                } else {
                    const res: any = await solicitarArchivo({ docId: data.docId }, idToken);
                    if(!res.error) {
                        cargarPdf(idToken, { docId: data.docId, doc: res.data });
                    }
                }
            } catch (error: any) {
                ocultarLoader();
                console.error(error);
                alert(`No se pudo firmar el documento.\n\nDetalle: ${error.message || "Error desconocido"}\n\n⚠️ Si el PDF está protegido con contraseña, elimínela antes.`);
            }
        } else {
            // Es biométrica, abrimos la caja para dibujar
            console.log("Mostramos caja de firma");
            mostrar("popUpFirma");
        }
    };
}

/**
 * Muestra error al usuario
 * @param msg string mensaje que se le mostrara al usuario
 * @param pantallaCompleta bollean muestra el error en pantalla completa o no
 * @return void
 */
const mostrarError = (msg:string, pantallaCompleta:Boolean=false) => {
    const global = document.getElementById("global-wrapper") as HTMLDivElement;
    const error = document.getElementById("error") as HTMLDivElement;
    global.classList.remove("remove-loader");
    global.classList.add("mostrar-error");
    global.classList.remove("mostrar-mensajeDocumentoFirmado");

    if(pantallaCompleta){
        global.classList.remove("hide");
        error.innerHTML = msg;
    }else{
        global.classList.add("hide");
        alert(msg);
    }
    console.error(msg);
}

/**
 * Muestra el loader
 * @param msg string mensaje que se le mostrara al usuario mientras carga
 * @return void
 */
const mostrarLoader = (msg:string="") => {
    const global = document.getElementById("global-wrapper") as HTMLDivElement;
    const loaderText = document.getElementById("loader-text") as HTMLDivElement;
    global.classList.remove("hide");
    global.classList.add("mostrar-loader");
    global.classList.remove("mostrar-error");
    global.classList.remove("mostrar-mensajeDocumentoFirmado");
    loaderText.innerHTML = msg;
}

/**
 * Oculta el loader
 * @return void
 */
const ocultarLoader = () => {
    const global = document.getElementById("global-wrapper") as HTMLDivElement;
    global.classList.add("hide");
    global.classList.remove("mostrar-loader");
    global.classList.remove("mostrar-mensajeDocumentoFirmado");
}

/**
 * Mostrar el mensaje DocumentoFirmado
 * @return void
 */
const mostrarMensajeDocumentoFirmado = (msg:string) => {
    const global = document.getElementById("global-wrapper") as HTMLDivElement;
    const mensajeDocumentoFirmado = document.getElementById("mensajeDocumentoFirmado") as HTMLDivElement;
    mensajeDocumentoFirmado.innerHTML = msg;
    global.classList.remove("hide");
    global.classList.remove("mostrar-error");
    global.classList.add("mostrar-mensajeDocumentoFirmado");
}


// --- FUNCIONES DEL PANEL DE ADMINISTRACIÓN ---

const obtenerContenedorAdmin = (): HTMLDivElement => {
    let container = document.getElementById("admin-app") as HTMLDivElement;
    if (!container) {
        container = document.createElement("div");
        container.id = "admin-app";
        // Estilos básicos para garantizar visibilidad y superposición
        container.style.width = "100%";
        container.style.minHeight = "100vh";
        container.style.backgroundColor = "#f4f6f9"; 
        container.style.position = "absolute"; 
        container.style.top = "0";
        container.style.left = "0";
        container.style.zIndex = "1000"; // Encima de todo
        document.body.appendChild(container);
    }
    container.style.display = "block"; 
    return container;
}

const renderLogin = () => {
    const container = obtenerContenedorAdmin();
    container.innerHTML = ""; 
    
    // Botón con tu color verde corporativo #4dd702
    container.innerHTML = `
        <div id="admin-login" style="max-width:400px; margin: 80px auto; padding:30px; border:1px solid #ccc; border-radius:10px; text-align:center; background:white; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
            <h2 id="formTitle" style="margin-bottom:20px; color:#333;">Acceso Clientes</h2>
            <div style="display:flex; flex-direction:column; gap:15px;">
                <input type="email" id="email" placeholder="Email" style="padding:12px; border:1px solid #ddd; border-radius:5px;" />
                <input type="password" id="password" placeholder="Contraseña" style="padding:12px; border:1px solid #ddd; border-radius:5px;" />
                <button id="btnAction" style="padding:12px; background:#4dd702; color:white; border:none; border-radius:5px; cursor:pointer; font-weight:bold; font-size:16px;">ENTRAR</button>
            </div>
            <p id="msgLogin" style="color:red; margin-top:15px; font-size:14px; min-height:20px;"></p>
            <div style="margin-top:20px; border-top:1px solid #eee; padding-top:20px;">
                <span id="toggleText">¿No tienes cuenta?</span>
                <a href="#" id="toggleBtn" style="color:#007bff; font-weight:bold; text-decoration:none;">Regístrate aquí</a>
            </div>
        </div>
    `;
    
    let isRegisterMode = false;
    const btnAction = document.getElementById("btnAction") as HTMLButtonElement;
    const toggleBtn = document.getElementById("toggleBtn") as HTMLAnchorElement;
    const formTitle = document.getElementById("formTitle") as HTMLElement;
    const msgLabel = document.getElementById("msgLogin") as HTMLElement;
    const toggleText = document.getElementById("toggleText") as HTMLElement;

    toggleBtn.addEventListener("click", (e) => {
        e.preventDefault();
        isRegisterMode = !isRegisterMode;
        if (isRegisterMode) {
            formTitle.innerText = "Registro Nuevo Usuario";
            btnAction.innerText = "CREAR CUENTA";
            toggleText.innerText = "¿Ya tienes cuenta?";
            toggleBtn.innerText = "Inicia Sesión";
            btnAction.style.background = "#28a745";
        } else {
            formTitle.innerText = "Acceso Clientes";
            btnAction.innerText = "ENTRAR";
            toggleText.innerText = "¿No tienes cuenta?";
            toggleBtn.innerText = "Regístrate aquí";
            btnAction.style.background = "#4dd702";
        }
        msgLabel.innerText = "";
    });
    
    btnAction.addEventListener("click", async () => {
        const email = (document.getElementById("email") as HTMLInputElement).value;
        const pass = (document.getElementById("password") as HTMLInputElement).value;

        if(!email || !pass) {
            msgLabel.innerText = "Email y contraseña requeridos";
            return;
        }
        mostrarLoader(isRegisterMode ? "Creando cuenta..." : "Verificando credenciales...");
        try {
            if (isRegisterMode) {
                console.log("1. Creando usuario en Auth...");
                const userCredential = await createUserWithEmailAndPassword(auth, email, pass);
                console.log("2. Usuario creado en Auth. Intentando guardar en DB...");
                await registrarUsuarioEnDb(userCredential.user.uid, email); 
                console.log("3. ¡ÉXITO! Usuario guardado en Firestore.");
            } else {
                await signInWithEmailAndPassword(auth, email, pass);
            }
            window.location.reload(); 
        } catch (e:any) {
            ocultarLoader();
            console.error(e);
            let errorMsg = e.message;
            if (e.code === 'auth/wrong-password') errorMsg = "Contraseña incorrecta.";
            if (e.code === 'auth/user-not-found') errorMsg = "Usuario no encontrado.";
            msgLabel.innerText = errorMsg;
        }
    });
}

const loadDocsTable = async (filtro: string) => {
    mostrarLoader("Cargando lista...");
    const res = await obtenerDocumentosUsuario(filtro, idToken);
    ocultarLoader();

    const listContainer = document.getElementById("docs-list") as HTMLDivElement;
    
    if (res.error || !res.data || res.data.length === 0) {
        const filtroDisplay = filtro === 'Pendiente' ? 'pendientes' : 'firmados';
        listContainer.innerHTML = `<div style="text-align:center; padding:20px; color:#666;">No hay documentos ${filtroDisplay}</div>`;
        return;
    }

    let html = `<table class="custom-table">
        <thead>
            <tr>
                ${filtro === "Pendiente" ? `<th><input type="checkbox" id="selectAll"></th>` : ''}
                <th>Fecha Alta</th>
                ${filtro === "Firmados" ? `<th>Fecha Firma</th>` : ''}
                <th>Documento</th>
                <th>Destinatario</th>
                <th>Estado</th>
                <th>Acciones</th>
            </tr>
        </thead>
        <tbody>`;

    res.data.forEach((doc: any) => {
        // Formateamos ambas fechas. Si alguna no existe por algún motivo, ponemos un guion "-"
        const fechaAlta = doc.fecha_alta ? new Date(doc.fecha_alta).toLocaleDateString() : '-';
        const fechaFirma = doc.fecha_firma ? new Date(doc.fecha_firma).toLocaleDateString() : '-';
        
        const estadoClass = doc.estado === "Firmado" ? "badge-firmado" : "badge-pendiente";
        
        html += `<tr>`;
        if (filtro === "Pendiente") {
            html += `<td><input type="checkbox" class="doc-check" value="${doc.id}"></td>`;
        }
        
        // Imprimimos la fecha de alta siempre
        html += `<td>${fechaAlta}</td>`;
        
        // Imprimimos la fecha de firma SOLO si estamos en la pestaña de firmados
        if (filtro === "Firmados") {
            html += `<td>${fechaFirma}</td>`;
        }

        html += `
            <td style="font-weight:600">${doc.nombre_documento || 'Documento sin título'}</td>
            <td>${doc.email}</td>
            <td><span class="badge ${estadoClass}">${doc.estado}</span></td>
            <td>
                ${filtro === "Firmados" 
                    ? `<a href="${doc.url_documento_firmado}" target="_blank" class="btn-descargar">Descargar</a>` 
                    : `<button class="btn-ver" data-id="${doc.id}">Ver Documento</button>`} 
            </td>
        </tr>`;
    });
    
    html += `</tbody></table>`;
    listContainer.innerHTML = html;

    // Conexión de Checkboxes
    const checkAll = document.getElementById("selectAll");
    if (checkAll) {
        checkAll.addEventListener("change", (e: any) => {
            document.querySelectorAll(".doc-check").forEach((c: any) => c.checked = e.target.checked);
            updateSelection();
        });
    }

    document.querySelectorAll(".doc-check").forEach(c => c.addEventListener("change", updateSelection));
    document.querySelectorAll(".btn-ver").forEach(btn => btn.addEventListener("click", (e: any) => abrirModoVista(e.target.getAttribute("data-id"))));
    updateSelection();
};

let dashboardState: any = { selected: [] };

const updateSelection = () => {
    const checks = document.querySelectorAll(".doc-check:checked");
    dashboardState.selected = Array.from(checks).map((c: any) => c.value);
    const btn = document.getElementById("btnFirmarLoteAutoFirma") as HTMLButtonElement;
    if (btn) {
        const count = dashboardState.selected.length;
        if (count > 0) {
            btn.style.display = "inline-block";
            btn.innerText = `Firmar con AutoFirma (${count})`;
            if (count > 10) {
                btn.disabled = true;
                btn.innerText = `Seleccione 10 docs máx. (${count})`;
                btn.style.backgroundColor = "#ffc107"; // Un color de advertencia
            } else {
                btn.disabled = false;
                btn.style.backgroundColor = "#4dd702"; // Color original
            }
        } else {
            btn.style.display = "none";
        }
    }
}

const renderDashboard = async () => {
    const container = obtenerContenedorAdmin();
    container.innerHTML = `
        <div class="dashboard-container" style="max-width:1200px; margin:0 auto; padding:20px;">
            <header style="display:flex; justify-content:space-between; align-items:center; margin-bottom:30px; background:white; padding:15px; border-radius:8px; box-shadow:0 2px 5px rgba(0,0,0,0.05);">
                <h1 style="margin:0; font-size:24px; color:#333;">Panel de Firmas</h1>
                <div style="display:flex; gap:10px;">
                    <button id="btnLogout" style="padding:8px 20px; background:#dc3545; color:white; border:none; border-radius:4px; cursor:pointer;">Cerrar Sesión</button>
                </div>
            </header>
            
            <div class="actions-bar" style="display:flex; gap:10px; margin-bottom:20px; flex-wrap:wrap;">
                <button id="btnTabPendientes" class="active" style="padding:10px 20px; cursor:pointer;">Pendientes</button>
                <button id="btnTabFirmados" style="padding:10px 20px; cursor:pointer;">Firmados</button>
                <div style="flex-grow:1;"></div>
                <button id="btnFirmarLoteAutoFirma" style="display:none; padding:10px 20px; background:#4dd702; color:white; border:none; border-radius:4px; cursor:pointer;">Firmar con AutoFirma</button>
            </div>
            
            <div id="docs-list" style="background:white; border-radius:8px; padding:20px; box-shadow:0 2px 5px rgba(0,0,0,0.05); overflow-x:auto;"></div>
            
            <p style="font-size:12px; color:#666; text-align:center; margin-top:20px;">
                Para la firma por lotes es necesario tener <a href="https://firmaelectronica.gob.es/ciudadanos/descargas" target="_blank">AutoFirma</a> instalado.
            </p>
        </div>
    `;

    document.getElementById("btnLogout")?.addEventListener("click", () => {
        auth.signOut().then(() => window.location.reload());
    });

    const btnPend = document.getElementById("btnTabPendientes");
    const btnFirm = document.getElementById("btnTabFirmados");

    btnPend?.addEventListener("click", () => { 
        loadDocsTable("Pendiente");
        btnPend.classList.add("active");
        btnFirm?.classList.remove("active");
    });
    
    btnFirm?.addEventListener("click", () => { 
        loadDocsTable("Firmados");
        btnFirm.classList.add("active");
        btnPend?.classList.remove("active");
    });
    btnPend?.click();

    document.getElementById("btnFirmarLoteAutoFirma")?.addEventListener("click", async () => {
        if (dashboardState.selected.length === 0) {
            alert("Por favor, seleccione al menos un documento para firmar.");
            return;
        }

        try {
            const response = await orchestrateAutofirmaBatch(
                dashboardState.selected,
                idToken,
                false,
                mostrarLoader,
                ocultarLoader,
                (msg) => { alert(msg); } 
            );

            if (response.error) {
                alert(`Error en el proceso de firma: ${response.msg || 'Error desconocido.'}`);
            } else {
                const successCount = response.data?.signed_count || 0;
                const errorCount = response.data?.errors?.length || 0;
                alert(`Proceso de firma finalizado.\nDocumentos firmados: ${successCount}\nErrores: ${errorCount}`);
                loadDocsTable("Pendiente"); // Recargar la tabla
            }
        } catch (error: any) {
            ocultarLoader();
            console.error("Error al orquestar la firma en lote:", error);
            alert(`El proceso se ha detenido.\n\nDetalle: ${error.message || "Error desconocido"}\n\n⚠️ Asegúrese de que NINGUNO de los documentos seleccionados esté protegido con contraseña o dañado.`);
        }
    });
}

const abrirModoVista = async (docId: string | null) => {
    if (!docId) {
        console.error("abrirModoVista: docId es nulo.");
        alert("No se pudo abrir el documento (ID no encontrado).");
        return;
    }

    const adminApp = document.getElementById("admin-app") as HTMLDivElement;
    if(adminApp) adminApp.style.display = "none";

    const bodyRequest = { docId: docId };
    try {
        const res: any = await solicitarArchivo(bodyRequest, idToken);
        if(!res.error) {
            const data = { docId: docId, doc: res.data };
            cargarPdf(idToken, data, true); 
        }
    } catch(e) {
        alert("Error abriendo documento");
        if(adminApp) adminApp.style.display = "block";
    }
}
function agregarBotonVolver() {
    if(document.getElementById("btn-volver-dash")) return;
    const btn = document.createElement("button");
    btn.id = "btn-volver-dash";
    btn.innerText = "← Volver al Panel";
    btn.style.cssText = "position: fixed; top: 10px; left: 10px; z-index: 9999; padding: 10px 20px; background: #333; color: white; border: none; cursor: pointer; border-radius: 50px; font-family: Montserrat;";
    
    btn.addEventListener("click", () => {
        document.getElementById("admin-app")!.style.display = "block";
        document.getElementById("documentoIframe")!.style.display = "none";
        document.getElementById("btn-volver-dash")?.remove();
        loadDocsTable("Pendiente");
    });
    document.body.appendChild(btn);
}

window.addEventListener('DOMContentLoaded', () => {
    // Basado en el ejemplo oficial, es crucial inicializar el componente de AutoFirma
    // tan pronto como la página se carga para asegurar que la comunicación esté lista.
    if (typeof (window as any).AutoScript?.cargarAppAfirma === 'function') {
        (window as any).AutoScript.cargarAppAfirma();
    }
    inic();
});
